// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityQuestion.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var momentTimezone = require('moment-timezone');
  var actions = require('./Izenda.SecurityQuestionActions');
  const { isNil } = require('lodash/fp');
  var SecurityQuestion = function(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols="2">
          <p>{localization.getText('COMMON_LABEL_SECURITY_QUESTIONS')}</p>
        </GridLayout.Col>
        <GridLayout.Col cols="6">
          {currentUser.userSecurityQuestions.map(function(securityQuestion) {
            return <p key={securityQuestion.securityQuestionId}>{securityQuestion.question}</p>;
          })}
        </GridLayout.Col>
        <GridLayout.Col cols="2">
          <p>{localization.getText('COMMON_CRITERIA_LAST_EDITED')}:&nbsp;</p>
          <p>
            {!isNil(currentUser.securityQuestionLastChanged) &&
              momentTimezone(currentUser.securityQuestionLastChanged).format('MM/DD/YYYY')}
          </p>
        </GridLayout.Col>
        <GridLayout.Col className="u_textRight" cols="2">
          <p>
            <a onClick={props.openChangeSecurityQuestionsPopup}>
              {localization.getText('COMMON_LABEL_CHANGE_SECURITY_QUESTION')}
            </a>
          </p>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  SecurityQuestion.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(SecurityQuestion);
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/SecurityOptions/Izenda.SecurityQuestion.jsx